import { Injectable      } from '@angular/core';
import { UtilsManager    } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier        } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager  } from 'src/app/managers/request/request.manager';
import { ErrorManager    } from 'src/app/managers/error/error.manager';
import { MessageDetail } from 'src/app/beans/message/message.detail.bean';

@Injectable
({
  providedIn: 'root'
})

export class MessageHandler
{
    constructor
    (
      private _utils    : UtilsManager    ,
      private _notifier : NotifierManager ,
      private _request  : RequestManager  ,
      private _error    : ErrorManager    ,
    ) {}

    async getList( token: string, siteId: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show( 
            Notifier.WARNING                , 
            NotifierMessage.INVALID_PASSWORD,
          )
          return undefined
        } 

        if (!this._utils.checker().isValidId( siteId )){
          this._notifier.show( 
            Notifier.ERROR                 , 
            NotifierMessage.INVALID_SITE_ID,
          )
          return undefined
        }

        try
        {
          const response = await this._request.message().getList( token, siteId ).toPromise()

          if (this._error.hasError( response )){
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async getDetail( token: string, siteId: number, messageId: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show( 
            Notifier.WARNING                , 
            NotifierMessage.INVALID_PASSWORD,
          )
          return undefined
        } 

        if (!this._utils.checker().isValidId( siteId )){
          this._notifier.show( 
            Notifier.ERROR                 , 
            NotifierMessage.INVALID_SITE_ID,
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( messageId )){
          this._notifier.show( 
            Notifier.ERROR                    , 
            NotifierMessage.INVALID_MESSAGE_ID,
          )
          return undefined
        }

        try
        {
          const response = await this._request.message().getDetail( token, siteId, messageId ).toPromise()

          if (this._error.hasError( response )){
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async create( token: string, siteId: number, data: MessageDetail)
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show( 
            Notifier.WARNING                , 
            NotifierMessage.INVALID_PASSWORD,
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( siteId )) 
        {
          this._notifier.show( 
            Notifier.WARNING               , 
            NotifierMessage.INVALID_SITE_ID,
          )
          return undefined
        }

        if (!this._utils.checker().isValidText( data.text )) 
        {
          this._notifier.show( 
            Notifier.WARNING                , 
            NotifierMessage.INVALID_MSG_NAME,
          )
          return undefined
        }

        if (!this._utils.checker().isValidText( data.dateBegin )) 
        {
          this._notifier.show( 
            Notifier.WARNING                      , 
            NotifierMessage.INVALID_MSG_DATE_BEGIN,
          )
          return undefined
        }

        if (!this._utils.checker().isValidText( data.dateEnd )) 
        {
          this._notifier.show( 
            Notifier.WARNING                , 
            NotifierMessage.INVALID_MSG_DATE_END,
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( data.msgOrganizationId ) &&
            !this._utils.checker().isValidId( data.msgSiteId         ) &&
            !this._utils.checker().isValidId( data.msgServiceId      ) ) 
        {
          this._notifier.show( 
            Notifier.WARNING                  , 
            NotifierMessage.INVALID_MSG_VISIBILITY,
          )
          return undefined
        }

        try
        {
          const response = await this._request.message().create( token, siteId, data ).toPromise()

          if (this._error.hasError( response )){
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }
          else
          {
            this._notifier.show( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK,
            )

            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async update( token: string, siteId: number, messageId: number, data: MessageDetail )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show( 
            Notifier.WARNING                , 
            NotifierMessage.INVALID_PASSWORD,
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( siteId )){
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ID,
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( messageId )){
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_MESSAGE_ID,
          )
          return undefined
        }

        if (!this._utils.checker().isValidText( data.text )) 
        {
          this._notifier.show( 
            Notifier.WARNING                , 
            NotifierMessage.INVALID_MSG_NAME,
          )
          return undefined
        }

        if (!this._utils.checker().isValidText( data.dateBegin )) 
        {
          this._notifier.show( 
            Notifier.WARNING                  , 
            NotifierMessage.INVALID_MSG_DATE_BEGIN,
          )
          return undefined
        }

        if (!this._utils.checker().isValidText( data.dateEnd )) 
        {
          this._notifier.show( 
            Notifier.WARNING                , 
            NotifierMessage.INVALID_MSG_DATE_END,
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( data.msgOrganizationId ) &&
            !this._utils.checker().isValidId( data.msgSiteId         ) &&
            !this._utils.checker().isValidId( data.msgServiceId      ) ) 
        {
          this._notifier.show( 
            Notifier.WARNING                  , 
            NotifierMessage.INVALID_MSG_VISIBILITY,
          )
          return undefined
        }

        try
        {
          const response = await this._request.message().update( token, siteId, messageId, JSON.stringify(data)).toPromise()

          if (this._error.hasError( response )){
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }
          else
          {
            this._notifier.show( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK,
            )

            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async delete( token: string, siteId:number, messageId: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show( 
            Notifier.WARNING                , 
            NotifierMessage.INVALID_PASSWORD,
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( siteId )){
          this._notifier.show( 
            Notifier.WARNING               , 
            NotifierMessage.INVALID_SITE_ID,
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( messageId )){
          this._notifier.show( 
            Notifier.WARNING                  , 
            NotifierMessage.INVALID_MESSAGE_ID,
          )
          return undefined
        }

        try
        {
          const response = await this._request.message().delete( token, siteId, messageId ).toPromise()

          if (this._error.hasError( response )){
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }
          else
          {
            this._notifier.show( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK,
            )

            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }
}

